export interface IAlertObject {
    type: EAlertType;
    message: string;
}

export enum EAlertType {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING'
}

export interface ILatestError {
    description: string;
    statusCode: string | number;
    traceId: string;
}

export type TAlertType = keyof typeof EAlertType;

export const ALERT_STACK_LENGTH = 5;

export const ALERT_DURATION = 20000;